import React from 'react'
import { RectShape } from 'react-placeholder/lib/placeholders'
import { CoresEnum } from './../../enums'

export const skeletonChip = (
  <RectShape color={CoresEnum.GRAY_100.value} style={{ width: 70, height: 32, borderRadius: 32 }} />
)
